import { render } from "./SearchRefunds.vue?vue&type=template&id=6167912e&scoped=true"
import script from "./SearchRefunds.vue?vue&type=script&lang=js"
export * from "./SearchRefunds.vue?vue&type=script&lang=js"

import "./SearchRefunds.vue?vue&type=style&index=0&id=6167912e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6167912e"]])

export default __exports__